import { authRoles } from 'components/auth'
import AdvanceCreditPolicyPage from '../advanced-credit-policy/AdvanceCreditPolicyPage'

export const CreditPolicyPageConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  auth: authRoles.user,
  routes: [
    {
      path: '/creditpolicy',
      component: AdvanceCreditPolicyPage,
    },
  ],
}
